import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { FrameItem } from "../../../page/ThirdScreen/qrSettings/framesQr/QrFrameItems";
import QRCodeStyling from "qr-code-styler";
import QrTemplate from "../../qrTemplate/QrTemplate";
import { getBase64PngFromBase64PSvg } from "../../../hooks/helpers";
import { getBase64Logo } from "../../../hooks/helpersThirdStep";
import { defaultLogo } from "../../../page/ThirdScreen/qrSettings/logotypeQr/svg";

const QrModalPreview = ({ selectedFrame, template }) => {
  const { qrSettings, getQrLinkSlice, qrOptions } = useSelector((state) => ({
    qrSettings: state.qrSettings,
    getQrLinkSlice: state.getQrLinkSlice,
    qrOptions: state.qrOptions,
  }));

  const {
    patternColor,
    pattern,
    cornetsOuter,
    cornetsOuterColor,
    cornetsInterior,
    cornetsInteriorColor,
    logotype,
    logotypeSize,
    logotypeMargin,
    logotypeBackground,
    isSingleColorDots,
    gradientDots,
    isSingleColorExternalEye,
    gradientExternalEye,
    isSingleColorInternalEye,
    gradientInternalEye,
    isSingleColorBackground,
    gradientBackground,
    qrBackgroundColor,
  } = template ? template.qrSettings : qrSettings;

  let ref = useRef(null);
  const qrCode = new QRCodeStyling({
    width: 300,
    height: 300,
    type: "canvas",
  });
  useEffect(() => {
    let canvas = ref.current !== null && ref.current.querySelector("canvas");
    canvas && canvas.remove();
    let getSvg = template
      ? template.qrSettings.logotype
      : qrSettings.logotype &&
        defaultLogo.find((findElem) =>
          findElem.id === template
            ? template.qrSettings.logotype
            : qrSettings.logotype
        );
    const updateQrCode = async () => {
      qrCode.update({
        data: getQrLinkSlice.link,
        image: !!getSvg
          ? await getBase64Logo(logotype)
          : await getBase64PngFromBase64PSvg(logotype),
        dotsOptions: {
          color: patternColor,
          type: pattern,
          gradient: isSingleColorDots ? null : gradientDots,
        },
        cornersSquareOptions: {
          color: cornetsOuterColor,
          type: cornetsOuter,
          gradient: isSingleColorExternalEye ? null : gradientExternalEye,
        },
        cornersDotOptions: {
          color: cornetsInteriorColor,
          type: cornetsInterior,
          gradient: isSingleColorInternalEye ? null : gradientInternalEye,
        },
        imageOptions: {
          imageSize: logotypeSize,
          margin: logotypeMargin,
          hideBackgroundDots: logotypeBackground,
        },
        backgroundOptions: {
          gradient:
            isSingleColorBackground === false
              ? gradientBackground
              : {
                  colorStops: [
                    {
                      offset: 0,
                      color:
                        isSingleColorBackground == true
                          ? qrBackgroundColor
                          : "transparent",
                    },
                    {
                      offset: 1,
                      color:
                        isSingleColorBackground == true
                          ? qrBackgroundColor
                          : "transparent",
                    },
                  ],
                },
        },
        qrOptions: {
          errorCorrectionLevel: qrOptions.errorCorrectionLevel,
        },
      });
      qrCode.append(ref.current);
    };
    updateQrCode();
  }, [qrOptions, qrSettings, getQrLinkSlice, selectedFrame, template]);

  return (
    <FrameItem>
      <QrTemplate
        gRef={ref}
        canvasQr={true}
        selectedFrame={selectedFrame}
        template={template}
      />
    </FrameItem>
  );
};

export default QrModalPreview;
